<template>
  <div class="tile-grid-item" :class="classModifiers">
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "default",
  },
});

const classModifiers = computed(() => ({
  [`--type-${props.type}`]: true,
}));
</script>

<style lang="scss" scoped>
.tile-grid-item {
  --content-padding: var(--sp-comp-dtv-tile-grid-item-padding, 0.75rem);
  --border: var(--sp-comp-dtv-tile-grid-item-border-width, 1px) var(--sp-comp-dtv-tile-grid-item-border-style, solid)
    var(--sp-comp-dtv-tile-grid-item-border-color, var(--sp-sys-color-primary, #00818a));
  --focus-outline: var(--sp-comp-dtv-tile-grid-item-focus-outline, var(--border));
  --focus-outline-offset: var(--sp-comp-dtv-tile-grid-itm-focus-outline-offset, 2px);

  display: flex;
  padding: var(--content-padding);
  border: var(--border);
  border-radius: var(--sp-comp-dtv-tile-grid-item-border-radius, var(--sp-sys-shape-control, 0));
  min-height: var(--sp-comp-dtv-tile-grid-item-min-height, 2rem);

  &.--type-radio {
    overflow: hidden;
    padding: 0;
    --sp-comp-dtv-radio-btn-padding-inline: var(--content-padding);

    &:has(.--focus) {
      outline: var(--focus-outline);
      outline-offset: var(--focus-outline-offset);
    }
  }
}
</style>
